import http from '@monolith/legacy/services/api/http';
import { RawMenuItem } from '../composables/use-account-menu';

export const getAccountMenu = async (): Promise<RawMenuItem[]> =>
  await http()
    .get(`/api/me/menu`)
    .then((response) => response.data.data);
